import React from "react"
import "./styles.scss"
import Img from "gatsby-image"
import TLink from "../../transitions/TLink"

const HeroFeaturedArticle = ({
  title,
  imageDesktop,
  imageMobile,
  articleCustomUrl,
  date,
  category,
  timeToRead,
  addOverlayOnHero,
}) => {
  function parseDate(articleDate) {
    const date = new Date(articleDate)
    const year = date.getUTCFullYear()
    return `${date.toLocaleString("en-GB", { month: "long" })} ${year}`
  }
  const sources = [
    {
      ...imageDesktop,
      media: `(max-width: 767px)`,
    },
  ]
  return (
    <section className="section section--heroFeaturedArticle">
      <Img
        style={{
          position: "absolute",
          zIndex: "-1",
          top: 0,
          left: 0,
          width: "100%",
          height: "720px",
        }}
        fluid={sources}
      />
      {addOverlayOnHero && <div className="wrapper-overlay"></div>}
      <div
        data-sal="slide-up"
        data-sal-easing="ease"
        data-sal-duration="1000"
        className="wrapper--text"
      >
        <div className="heroFeaturedArticle">
          <div className="heroFeaturedArticle__data">
            <span>{category} </span>
            <span> &#183; {parseDate(date)} &#183; </span>
            <span> {timeToRead} min read</span>
          </div>
          <h1 className="heroFeaturedArticle__title">{title}</h1>
          <TLink
            className="btn btn--bordered"
            to={
              articleCustomUrl
                ? articleCustomUrl
                : title.toLowerCase().split(" ").slice(0, 3).join("-")
            }
          >
            Read Article
          </TLink>
        </div>
      </div>
    </section>
  )
}

export default HeroFeaturedArticle
